// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__nkqvp","section-header":"menu_section-header__29imW"};